<template>
  <div
    class="share-block d-flex"
    :style="{
      padding: blockPadding
    }"
  >
    <share-network
      v-for="platform in platforms"
      :key="platform.name"
      :class="[
        'share-block__button v-button --small --secondary p-0',
        `--${platform.name}`
      ]"
      :network="platform.name"
      :url="urlGiveOrCurrent"
      :title="title"
    >
      <img :src="platform.icon()" :alt="platform.title" />
    </share-network>

    <a
      v-if="canNativelyShare"
      href="javascript:void(0)"
      @click="nativeShare"
      class="share-block__button v-button --small --secondary p-1"
    >
      <img :src="require('@/assets/images/icons/ios-share.svg')" />
    </a>

    <div v-if="isBuilderContext()" class="share-block__readonly" />
  </div>
</template>

<script>
import { ShareNetwork } from "vue-social-sharing"

import { isBuilderContext } from "@/lib/utils"
import { toPadding } from "@/lib/stream-utils"

const PLATFORMS = {
  facebook: {
    name: "facebook",
    title: "Facebook",
    icon: () => require("@/assets/images/icons/social/facebook.svg")
  },
  email: {
    name: "email",
    title: "Email",
    icon: () => require("@/assets/images/icons/social/email.svg")
  },
  linkedin: {
    name: "linkedin",
    title: "LinkedIn",
    icon: () => require("@/assets/images/icons/social/linkedin.svg")
  },
  messenger: {
    name: "messenger",
    title: "Messenger",
    icon: () => require("@/assets/images/icons/social/messenger.svg")
  },
  twitter: {
    name: "twitter",
    title: "Twitter",
    icon: () => require("@/assets/images/icons/social/twitter.svg")
  },
  whatsapp: {
    name: "whatsapp",
    title: "Whatsapp",
    icon: () => require("@/assets/images/icons/social/whatsapp.svg")
  },
  reddit: {
    name: "reddit",
    title: "Reddit",
    icon: () => require("@/assets/images/icons/social/reddit.svg")
  },
  pinterest: {
    name: "pinterest",
    title: "Pinterest",
    icon: () => require("@/assets/images/icons/social/pinterest.svg")
  },
  sms: {
    name: "sms",
    title: "SMS",
    icon: () => require("@/assets/images/icons/social/sms.svg")
  }
}

export const SHARE_PLATFORMS = Object.keys(PLATFORMS)

export default {
  components: {
    ShareNetwork
  },

  props: {
    url: { type: String, default: "" },
    title: { type: String, default: "" },

    visiblePlatforms: { type: Array, default: () => SHARE_PLATFORMS },

    spaceXRatio: {
      type: Number,
      default: 0
    },
    spaceTopRatio: {
      type: Number,
      default: 0
    },
    spaceBottomRatio: {
      type: Number,
      default: 0
    }
  },

  computed: {
    platforms() {
      const result = []

      this.visiblePlatforms.forEach(name => {
        if (PLATFORMS[name]) {
          result.push(PLATFORMS[name])
        }
      })

      return result
    },

    blockPadding() {
      return toPadding(
        this.spaceTopRatio,
        this.spaceXRatio,
        this.spaceBottomRatio
      )
    },

    canNativelyShare() {
      return !!window.navigator.share
    },

    currentUrlWithoutQueryOrHash() {
      const { href, search, hash } = window.location
      return href.replace(search, "").replace(hash, "")
    },

    urlGiveOrCurrent() {
      return this.url || this.currentUrlWithoutQueryOrHash
    }
  },

  methods: {
    isBuilderContext,
    nativeShare() {
      window.navigator.share({
        title: this.title,
        url: this.urlGiveOrCurrent
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.share-block {
  justify-content: center;
  display: flex;
  position: relative;
  flex-wrap: wrap;
}

.share-block__button {
  display: inline-block;
  margin: $size--1;
  background-color: $color-ui--white !important;
  width: 40px;
  height: 40px;
  border-radius: $size--1;
  &:first-child {
    margin-left: 0;
  }

  &.--sms {
    padding: 0.2rem !important;
  }

  img {
    width: 100%;
    height: 100%;
  }
}

.share-block__readonly {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
